import { Controller, useFormContext } from 'react-hook-form';

import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { severityOptions } from '@kirin/api-client/contracts/shared/severity';
import type { SiemFormValues } from './types';

export function MinimumSeverityField() {
  const { control } = useFormContext<SiemFormValues>();

  return (
    <div className="space-y-2">
      <Label className="font-semibold">Minimum Log Severity</Label>
      <Controller
        control={control}
        name="minimumSeverity"
        render={({ field }) => (
          <Select value={field.value} onValueChange={field.onChange}>
            <SelectTrigger className="w-full text-primary">
              <SelectValue placeholder="Select severity" />
            </SelectTrigger>
            <SelectContent>
              {severityOptions.map(option => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      />
      <p className="text-xs text-foreground/80">
        Only events at or above this severity will be forwarded
      </p>
    </div>
  );
}
